import React from 'react';
import { Section } from './Shared';
export const ProblemSolution = () => {
  return <>
      {/* Pain Section */}
      <Section bg="dark" data-id="element-249">
        <div className="max-w-3xl mx-auto" data-id="element-250">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-8 text-center" data-id="element-251">
            ¿Cuántas clientas más vas a dejar ir sin un sistema?
          </h2>

          <div className="font-montserrat text-lg space-y-4 mb-10 text-gray-300" data-id="element-252">
            <p data-id="element-253">Sos buena en lo que hacés. Eso está clarísimo.</p>
            <p data-id="element-254">Pero nadie te enseñó a vender. Nadie te dio un sistema.</p>
            <p data-id="element-255">
              Y ahora hacés todo sola. Atendés, publicás, respondés, organizás,
              comprás, cobrás.
            </p>
            <p data-id="element-256">Y aun así el negocio no termina de despegar.</p>
          </div>

          <ul className="space-y-4 font-montserrat text-base md:text-lg mb-12" data-id="element-257">
            <li className="flex items-start gap-3" data-id="element-258">
              <span className="shrink-0" data-id="element-259">❌</span>{' '}
              <span data-id="element-260">Subís contenido y nadie te escribe</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-261">
              <span className="shrink-0" data-id="element-262">❌</span>{' '}
              <span data-id="element-263">Te preguntan precio por DM y desaparecen</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-264">
              <span className="shrink-0" data-id="element-265">❌</span>{' '}
              <span data-id="element-266">Querés cobrar más pero te da miedo perder clientas</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-267">
              <span className="shrink-0" data-id="element-268">❌</span>{' '}
              <span data-id="element-269">Tu agenda depende de la suerte, no de un sistema</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-270">
              <span className="shrink-0" data-id="element-271">❌</span>{' '}
              <span data-id="element-272">Tus clientas no vuelven solas</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-273">
              <span className="shrink-0" data-id="element-274">❌</span>{' '}
              <span data-id="element-275">No sabés qué publicar ni qué responder por WhatsApp</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-276">
              <span className="shrink-0" data-id="element-277">❌</span>{' '}
              <span data-id="element-278">Trabajás mucho y el número no refleja todo lo que das</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-279">
              <span className="shrink-0" data-id="element-280">❌</span>{' '}
              <span data-id="element-281">
                Mirás lo que hacen otras y no entendés por qué a ellas les
                funciona
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-282">
              <span className="shrink-0" data-id="element-283">❌</span>{' '}
              <span data-id="element-284">
                Fin de semana agotada. Lunes volvés a empezar el mismo ciclo.
              </span>
            </li>
          </ul>

          <div className="text-center font-montserrat text-xl md:text-2xl font-bold text-brand mt-12" data-id="element-285">
            <p className="mb-4" data-id="element-286">No es falta de talento. Es falta de sistema.</p>
            <p className="text-base text-white" data-id="element-287">
              ¿Y si esta fuera la última semana que pasás así?
            </p>
          </div>
        </div>
      </Section>

      {/* Who is it for */}
      <Section bg="mid" data-id="element-288">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-289">
          <div className="bg-base p-8 rounded-xl shadow-sm" data-id="element-290">
            <h3 className="font-playfair text-2xl font-bold mb-6 text-dark" data-id="element-291">
              ✅ Esto es para vos si...
            </h3>
            <ul className="space-y-4 font-montserrat text-gray-700" data-id="element-292">
              <li className="flex items-start gap-3" data-id="element-293">
                <span className="shrink-0" data-id="element-294">✅</span>{' '}
                <span data-id="element-295">
                  Sos manicurista, lashista, brow artist, esteticista,
                  cosmetóloga o peluquera
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-296">
                <span className="shrink-0" data-id="element-297">✅</span>{' '}
                <span data-id="element-298">Trabajás de forma independiente</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-299">
                <span className="shrink-0" data-id="element-300">✅</span>{' '}
                <span data-id="element-301">Usás Instagram y WhatsApp para conseguir clientas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-302">
                <span className="shrink-0" data-id="element-303">✅</span>{' '}
                <span data-id="element-304">
                  Sentís que hacés todo sola y el negocio no termina de despegar
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-305">
                <span className="shrink-0" data-id="element-306">✅</span>{' '}
                <span data-id="element-307">
                  Querés más clientas, más orden y cobrar lo que vale tu trabajo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-308">
                <span className="shrink-0" data-id="element-309">✅</span>{' '}
                <span data-id="element-310">
                  Necesitás un sistema listo para aplicar, no más teoría
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white/50 p-8 rounded-xl border border-gray-200" data-id="element-311">
            <h3 className="font-playfair text-2xl font-bold mb-6 text-dark" data-id="element-312">
              ❌ Esto NO es para vos si...
            </h3>
            <ul className="space-y-4 font-montserrat text-gray-700" data-id="element-313">
              <li className="flex items-start gap-3" data-id="element-314">
                <span className="shrink-0" data-id="element-315">❌</span>{' '}
                <span data-id="element-316">Buscás otro curso para ver y no aplicar</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-317">
                <span className="shrink-0" data-id="element-318">❌</span>{' '}
                <span data-id="element-319">Esperás resultados sin poner nada de tu parte</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-320">
                <span className="shrink-0" data-id="element-321">❌</span>{' '}
                <span data-id="element-322">
                  Ya tenés la agenda llena y un sistema que funciona perfecto
                </span>
              </li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Solution */}
      <Section bg="base" data-id="element-323">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-324">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-4 text-dark" data-id="element-325">
            💅 MEGAKIT MÁS CLIENTAS™
          </h2>
          <p className="font-montserrat text-xl md:text-2xl font-medium text-brand mb-8" data-id="element-326">
            El sistema listo para usar que te da más clientas, mejores ventas y
            un negocio ordenado.
          </p>
          <div className="font-montserrat text-lg text-gray-700 space-y-4" data-id="element-327">
            <p data-id="element-328">
              No es un curso que tenés que terminar. No es teoría que después
              aplicás sola. No es motivación vacía.
            </p>
            <p className="font-bold text-dark text-xl" data-id="element-329">
              Es un sistema. Abrís. Copiás. Aplicás. Vendés.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-100" data-id="element-330">
          <div className="overflow-x-auto" data-id="element-331">
            <table className="w-full text-left font-montserrat" data-id="element-332">
              <thead data-id="element-333">
                <tr className="bg-mid text-dark" data-id="element-334">
                  <th className="p-4 md:p-6 font-bold w-1/2" data-id="element-335">
                    ❌ Sin el Megakit
                  </th>
                  <th className="p-4 md:p-6 font-bold w-1/2 border-l border-white" data-id="element-336">
                    ✅ Con el Megakit
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-337">
                <tr data-id="element-338">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-339">
                    Improvisás el contenido cada semana
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-340">
                    50 scripts de reels listos para grabar
                  </td>
                </tr>
                <tr data-id="element-341">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-342">
                    No sabés qué responder por WhatsApp
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-343">
                    Respuestas exactas para cada situación
                  </td>
                </tr>
                <tr data-id="element-344">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-345">
                    No sabés cómo cobrar más
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-346">
                    Sistema completo para subir precios sin perder clientas
                  </td>
                </tr>
                <tr data-id="element-347">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-348">
                    Tus clientas no vuelven
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-349">
                    Protocolo de re-agendamiento automático
                  </td>
                </tr>
                <tr data-id="element-350">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-351">
                    Tu negocio depende del azar
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-352">
                    Planner completo para gestionar todo
                  </td>
                </tr>
                <tr data-id="element-353">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-354">
                    Creás promos a las corridas
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-355">
                    30 promos flash listas para publicar
                  </td>
                </tr>
                <tr data-id="element-356">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-357">
                    Tu feed se ve amateur
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-358">
                    Plantillas de Canva listas para editar
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Section>
    </>;
};